import equalHeights from 'global/equalHeights';

const productCarousel = () => {
	const carouselList = document.querySelectorAll('[data-product-carousel]');

	if (carouselList && carouselList.length > 0) {
		Array.from(carouselList).forEach(carousel => {
			const config = {
				autoWidth: true,
				responsiveClass: true,
				responsive: {
					0: {
						nav: false,
						loop: true,
					},
					1032: {
						nav: carousel.childElementCount > 4,
						loop: false,
					},
				},
			};

			window.od.carousel(carousel, config);
			equalHeights(carousel);
		});
	}
};

export default productCarousel;
